<template>
  <div>
    <b-card no-header>
      <form>
        <b-form-group
          label="Filename"
          label-for="fileName"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="fileName"
            :value="fileName" 
            type="text"
            readonly>
          </b-form-input>
        </b-form-group>

        <b-form-group
          label="Titulo"
          label-for="titulo"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="titulo"
            v-model.trim="$v.titulo.$model" 
            :state="tituloValido"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="tituloFeedback">
            {{ tituloInvalidoMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>

        <b-form-group
          label="Descripcion"
          label-for="descripcion"
          :label-cols="labelCols"
          horizontal>
          <b-form-textarea
            id="descripcion"
            v-model="$v.descripcion.$model" 
            rows="3"
            max-rows="5"
            :state="descripcionValida"
            @blur.native="validate">
          </b-form-textarea>
          <b-form-invalid-feedback id="descripcionFeedback">
            {{ descripcionInvalidaMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { maxLength } from 'vuelidate/lib/validators';

export default {
  name: 'EventoImagen',
  props: {
    imagen: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      fileName: '',
      titulo: '',
      descripcion: '',

      noValidar: true,
      tituloValido: null,
      tituloInvalidoMsj: '',
      descripcionValida: null,
      descripcionInvalidaMsj: '',

      labelCols: 2,
    }
  },
  created() {
    if (this.imagen) {
      this.fileName = this.imagen.fileName.trim();
      this.titulo = this.imagen.titulo.trim();
      this.descripcion = this.imagen.descripcion.trim();
    }
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
      
      if (campo == 'titulo' || validarTodos) {
        if (this.$v.campo.$error) {
          this.tituloValido = false;
          if (!this.$v.titulo.maxLength) {
            this.tituloInvalidoMsj = 'El titulo solo pueden contener hasta 150 caracteres';
          }      
        } else {
          this.tituloValido = null;
          this.tituloInvalidoMsj = '';
        }
      }

      if (campo == 'descripcion' || validarTodos) {
        if (this.$v.descripcion.$error) {
          this.descripcionValida = false;
          if (!this.$v.descripcion.maxLength) {
            this.descripcionInvalidaMsj = 'La descripción solo pueden contener hasta 5000 caracteres';
          }      
        } else {
          this.descripcionValida = null;
          this.descripcionInvalidaMsj = '';
        }
      }

    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;


      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        let params = {
          imagenId: this.imagen.id,
          titulo: this.titulo,
          descripcion: this.descripcion
        }
        this.showSpinner();
        this.$store.dispatch('eventoImagenes/updateImagen', params)
          .then(() => this.$emit('close'))
          .catch( error => this.showErrorMsj (error))
          .finally(() => this.hideSpinner());
      }
    },
    cancelar() {
      this.$emit('close')
    },
  },
  validations: {
    titulo: {
      maxLength: maxLength(150)
    },
    descripcion: {
      maxLength: maxLength(5000)
    },
  },  
  watch: {
  }    
}
</script>

<style>
</style>
